import React from "react"
import { useFormContext } from "react-hook-form"
import styled, { css } from "styled-components"
import PropTypes from "prop-types"

const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
`
const Label = styled.label`
  cursor: pointer;
  position: relative;
  display: inline-flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 15px;
  ${props =>
    props.variant === "blue"
      ? css`
          color: ${props.theme.darkBlue};
        `
      : undefined}
  @media only screen and (${props => props.theme.screen.small.min}) {
    font-size: 16px;
    line-height: 20px;
  }
`
const Input = styled.input`
  -moz-appearance: initial;
  position: relative;
  cursor: pointer;
  width: 14px;
  height: 14px;
  margin: 3px;
  display: inline-block;

  &::before,
  &::after {
    content: "";
    box-sizing: border-box;
    display: inline-block;
    position: absolute;
    z-index: 1;
    top: -3px;
    left: -3px;
    border-radius: 4px;
    width: 20px;
    height: 20px;
  }
  &::before {
    background-color: ${props => props.theme.bg1};
    border: 1px solid ${props => props.theme.black};
  }
  &::after {
    background-color: ${props =>
      props.variant === "blue" ? props.theme.darkBlue : props.theme.primary};
    transform: scale(0);
    transition: transform 0.1s ease-in;
  }

  &:focus::before {
    outline: ${props => props.theme.focusOutline};
    outline: -webkit-focus-ring-color auto 1px;
  }
  &:checked::before {
    border-color: ${props =>
      props.variant === "blue" ? props.theme.darkBlue : props.theme.primary};
  }
  &:checked::after {
    transform: scale(1);
    font-family: "icons-10a-v2" !important;
    content: "\\e960";
    font-size: 12px;
    padding: 4px;
  }

  ${Label} > & {
    margin-right: 12px;
  }
`

const Error = styled.div`
  color: red;
  font-size: 16px;
  font-weight: 700;
  margin-top: 6px;
  display: flex;
  flex-direction: column;
`

function InputCheckbox({ name, children, validate, variant }) {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  return (
    <>
      <CheckboxWrapper>
        <Input
          type="checkbox"
          id={name}
          {...register(name, { validate })}
          variant={variant}
        />
        <Label variant={variant}>{children}</Label>
      </CheckboxWrapper>
      {errors[name] && <Error>{errors[name].message}</Error>}
    </>
  )
}

InputCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  variant: PropTypes.string,
}

export default InputCheckbox
